<div class="user-email-change-dialog">
  <div mat-dialog-title>{{ 'Change_email' | translate }}</div>
  <mat-dialog-content>
    <div class="line">
      <mat-form-field>
        <input matInput
               type="email"
               [disabled]="true"
               [readonly]="true"
               [formControl]="currentEmailFormControl"
               placeholder="{{ 'Your_current_email' | translate }}">
        <mat-error *ngIf="currentEmailFormControl.hasError('required')">{{ 'Current_email_required' | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="line">
      <mat-form-field>
        <input matInput
               type="email"
               [formControl]="newEmailFormControl"
               (keyup)="onNewEmailEnter()"
               placeholder="{{ 'New_email' | translate }}">
        <mat-error *ngIf="newEmailFormControl.hasError('required')">{{ 'New_email_required' | translate }}</mat-error>
        <mat-error *ngIf="newEmailFormControl.hasError('email')">{{ 'Email_invalid' | translate }}</mat-error>
        <mat-error *ngIf="newEmailFormControl.hasError('unavailable')">{{ 'Email_unavailable' | translate }}</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate}}</button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent"
            [disabled]="isLoading
                  || newEmailFormControl.invalid
                  ? 'true' : null">
      {{ 'Save' | translate}}
    </button>
  </mat-dialog-actions>
  <div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
  </div>
</div>
